import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * バッテリーエンジン関連
 */
const EngineTroubleIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g transform="translate(-112 -228.427)">
          <rect
            width="40"
            height="40"
            rx="6"
            transform="translate(112 228.427)"
            fill={CLIENT_SETTINGS.colors.background}
          />
          <g transform="translate(115 238.427)">
            <path
              d="M149,255.427h-3.824a13.176,13.176,0,0,0-26.351,0H115a17,17,0,0,1,34,0Z"
              transform="translate(-115 -238.427)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
          <path
            d="M426.13,392.927l4.95-5.439-.7-.719-5.857,4.595A3.65,3.65,0,0,1,426.13,392.927Z"
            transform="translate(-291.058 -139.494)"
            fill={CLIENT_SETTINGS.colors.main}
          />
          <g transform="translate(128.775 252.033)">
            <ellipse
              cx="2.577"
              cy="2.577"
              rx="2.577"
              ry="2.577"
              transform="translate(0 5.021) rotate(-76.963)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
          <g transform="translate(131.423 243.673)">
            <rect
              width="1.154"
              height="2.465"
              transform="translate(0)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
          <g transform="translate(125.756 244.852)">
            <rect
              width="1.154"
              height="2.465"
              transform="translate(0 0.577) rotate(-30)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
          <g transform="translate(121.727 248.784)">
            <rect
              width="1.154"
              height="2.465"
              transform="translate(0 0.999) rotate(-60)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
          <g transform="translate(120.414 254.415)">
            <rect
              width="2.465"
              height="1.154"
              transform="translate(0 0)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
          <g transform="translate(140.854 254.682)">
            <rect
              width="2.465"
              height="1.154"
              transform="translate(0 0)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
          <g transform="translate(139.428 249.015)">
            <rect
              width="2.465"
              height="1.154"
              transform="matrix(0.866, -0.5, 0.5, 0.866, 0, 1.233)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
          <g transform="translate(135.976 244.986)">
            <rect
              width="2.465"
              height="1.154"
              transform="translate(0 2.135) rotate(-59.998)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
        </g>
      </svg>
    </Icon>
  )
}

export default EngineTroubleIcon
